import { ExpandableTableRenderer, type } from './ExpandableTable';

class CustomFormFields {
  constructor(formFields) {
    formFields.register(type, ExpandableTableRenderer);
  }
}

export default {
  __init__: ['expandableTableField'],
  expandableTableField: ['type', CustomFormFields],
};
